import {
  selectRootNodesBySection,
  selectSectionsByTab,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { collectNodeWithChildren } from '@store/reducers/ai/utils/collectNodeWithChildren'
import type { AppState } from '@store/types'

export const selectAIRemainingRequests = (state: AppState) =>
  state.ai.remainingRequests

export const selectAIMessages = (state: AppState) => state.ai.messages

export const selectAIGenerating = (state: AppState) => state.ai.generating

export const selectAIHistoryLoading = (state: AppState) =>
  state.ai.historyLoading

export const selectAIError = (state: AppState) => state.ai.error

export const selectAICancelTokenSource = (state: AppState) =>
  state.ai.cancelTokenSource

// v2 (chat-agent) streaming selectors.
export const selectAISessionId = (state: AppState) => state.ai.sessionId

export const selectAIStreamingText = (state: AppState) => state.ai.streamingText

export const selectAIAgentStep = (state: AppState) => state.ai.agentStep

export const selectAIAgentStatus = (state: AppState) => state.ai.agentStatus

export const selectAILastSentMessage = (state: AppState) =>
  state.ai.lastSentMessage

export const selectConvertedProject = (state: AppState) => {
  const currentTabId = migrationProjectSelector.getActiveOrFirstTabId(state)

  const sections = selectSectionsByTab(currentTabId)(state)

  return {
    type: 'tab',
    id: currentTabId,
    defaultColor: state.manager.project.settings.defaultColor,
    colors: state.manager.project.colors.map((color) => ({
      id: color.id,
      title: color.title,
      hexCode: color.hexCode,
    })),
    children: sections.map((sectionId) => {
      const section =
        migrationProjectSelector.getProjectSectionById(sectionId)(state)

      if (!section) {
        return null
      }

      const nodes = selectRootNodesBySection(sectionId)(state)

      return {
        id: sectionId,
        title: section.title,
        index: section.order,
        children: nodes.map((nodeId, index) =>
          collectNodeWithChildren(nodeId, index, state)
        ),
      }
    }),
  }
}
